import { useTranslation } from '@bonanza-social/i18n';
import SOFComponent from '../components/SOF/SOFComponent';
import { Screen, useNavigation } from '@bonanza-social/navigation';
import { useEffect } from 'react';

function SOFAttestationScreen() {
  const { t } = useTranslation('account');
  const navigation = useNavigation();

  useEffect(() => {
    navigation.setOptions({ title: t('SOFScreenName') });
  }, [navigation, t]);

  return (
    <Screen>
      <SOFComponent />
    </Screen>
  );
}

export default SOFAttestationScreen;
